import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAdminAuth, formatApiError } from "@/admin/AdminAuthContext";

export default function AdminChangePassword() {
  const { user, changePassword } = useAdminAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 10) return setError("New password must be at least 10 characters.");
    if (next !== confirm) return setError("New password confirmation does not match.");
    setBusy(true);
    try {
      await changePassword(current, next);
      toast.success("Password changed.");
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  const mustChange = user?.must_change_password;

  return (
    <div data-testid="admin-change-password-page" className="max-w-xl">
      <div className="mb-8">
        <div className="text-gold text-[11px] uppercase tracking-[0.28em] font-medium mb-2">Security</div>
        <h1 className="font-serif text-navy text-3xl mb-2">Change password</h1>
        <p className="text-mutedink text-sm">
          {mustChange
            ? "You are signed in with a temporary password. Please choose a new one to continue."
            : "Update the password for your admin account."}
        </p>
      </div>

      <form onSubmit={submit} className="bg-white border border-softgray p-8 space-y-5" data-testid="admin-change-password-form">
        <div>
          <label className="block text-navy text-xs uppercase tracking-[0.18em] font-semibold mb-2">Current password</label>
          <input type="password" required autoComplete="current-password"
                 value={current} onChange={(e) => setCurrent(e.target.value)}
                 data-testid="cp-current"
                 className="w-full border border-softgray px-4 py-3 text-navy outline-none focus:border-gold" />
        </div>
        <div>
          <label className="block text-navy text-xs uppercase tracking-[0.18em] font-semibold mb-2">New password (min 10 chars)</label>
          <input type="password" required minLength={10} autoComplete="new-password"
                 value={next} onChange={(e) => setNext(e.target.value)}
                 data-testid="cp-new"
                 className="w-full border border-softgray px-4 py-3 text-navy outline-none focus:border-gold" />
        </div>
        <div>
          <label className="block text-navy text-xs uppercase tracking-[0.18em] font-semibold mb-2">Confirm new password</label>
          <input type="password" required minLength={10} autoComplete="new-password"
                 value={confirm} onChange={(e) => setConfirm(e.target.value)}
                 data-testid="cp-confirm"
                 className="w-full border border-softgray px-4 py-3 text-navy outline-none focus:border-gold" />
        </div>
        {error && <div className="text-sm text-red-700 bg-red-50 border border-red-200 px-4 py-3" data-testid="cp-error">{error}</div>}
        <button type="submit" className="btn-gold" disabled={busy} data-testid="cp-submit">
          {busy ? "Saving…" : "Update password"}
        </button>
      </form>
    </div>
  );
}
